import { render, staticRenderFns } from "./AdditionalService.vue?vue&type=template&id=01fb9a35&scoped=true&"
import script from "./AdditionalService.vue?vue&type=script&lang=js&"
export * from "./AdditionalService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fb9a35",
  null
  
)

export default component.exports